/**
 * @generated SignedSource<<28c0c6d5355cae454f8487f92851f2d4>>
 * @relayHash 2717c116c350be71b136583217387205
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2717c116c350be71b136583217387205

import { ConcreteRequest } from 'relay-runtime';
export type ContactChannel = "APP" | "EMAIL_AND_SMS" | "NO_CHANNEL";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type useChDuplicatePatientChangedSubscription$variables = Record<PropertyKey, never>;
export type useChDuplicatePatientChangedSubscription$data = {
  readonly ch_patientChanged: {
    readonly contactChannel: ContactChannel;
    readonly country: Country;
    readonly displayId: number;
    readonly firstName: string;
    readonly gender: Gender;
    readonly id: string;
    readonly lastName: string;
  };
};
export type useChDuplicatePatientChangedSubscription = {
  response: useChDuplicatePatientChangedSubscription$data;
  variables: useChDuplicatePatientChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_Patient",
    "kind": "LinkedField",
    "name": "ch_patientChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gender",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactChannel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDuplicatePatientChangedSubscription",
    "selections": (v0/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useChDuplicatePatientChangedSubscription",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "2717c116c350be71b136583217387205",
    "metadata": {},
    "name": "useChDuplicatePatientChangedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "d4033a528ad69d5fcba5c0f7773c3667";

export default node;
